import React, { useState } from "react";
import "../styles/SolutionsSections.css";

const solutions = [
  {
    title: "Finance & Accounting",
    img: "/images/finance.jpg",
    desc: "Streamline budgeting, invoicing, and payroll with ease.",
    features: [
      {
        name: "Budget Management",
        details: "Easily plan, allocate, and track budgets across streams.",
        benefits: "Improved cost control and financial visibility."
      },
      {
        name: "Automated Invoicing",
        details: "Generate and send invoices instantly with payment tracking.",
        benefits: "Saves time and reduces errors."
      },
      {
        name: "Analytics",
        details: "Accurate, visual, automated analytical data at your finger tips.",
        benefits: "Ensures timely and correct reporting."
      }
    ]
  },
  {
    title: "KYC for Your Business",
    img: "/images/kyc.jpg",
    desc: "Build trust, gain new client and manage client profiles while tranking their performance.",
    features: [
      {
        name: "Trusted Onboarding",
        details: "Quickly register and verify new customers with minimal friction.",
        benefits: "Boosts customer confidence and accelerates growth."
      },
      {
        name: "Seamless Compliance",
        details: "Integrated KYC processes that meet global standards automatically.",
        benefits: "Saves time, reduces manual checks, and keeps your business worry-free."
      },
      {
        name: "Customer Insights",
        details: "Track and update customer records in one secure system.",
        benefits: "Improves decision-making and strengthens long-term relationships."
      }
    ]
  },
  {
    title: "Operations Management",
    img: "/images/operations.jpg",
    desc: "Optimize workflows and track key operational metrics.",
    features: [
      {
        name: "Workflow Automation",
        details: "Automate routine tasks to improve efficiency.",
        benefits: "Saves time and reduces human error."
      },
      {
        name: "Inventory Tracking",
        details: "Real-time monitoring of stock levels and supplies.",
        benefits: "Avoids shortages and overstocking."
      },
      {
        name: "KPI Dashboards",
        details: "Visual reports to track operational performance.",
        benefits: "Improves decision-making and transparency."
      }
    ]
  },
  {
    title: "Industry Solutions",
    img: "/images/industry.jpg",
    desc: "Tailored tools for hotels, schools, local authorities, and more.",
    features: [
      {
        name: "Custom Templates",
        details: "We customize our tool for your unique workflows and reporting format.",
        benefits: "Faster onboarding and easier adaptation."
      },
      {
        name: "Integration Support",
        details: "Connect with POS, LMS, ERP, and other systems.",
        benefits: "Seamless data flow across tools."
      },
      {
        name: "Compliance Tools",
        details: "Built-in support for local regulations.",
        benefits: "Ensures legal compliance effortlessly."
      }
    ]
  }
];

export default function SolutionsSection() {
  const [expanded, setExpanded] = useState(null);

  const toggleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <section className="solutions-section">
      <h2 className="solutions-title">Our Solutions Offer</h2>
      <div className="solutions-grid">
        {solutions.map((solution, index) => (
          <div
            key={index}
            className={`solution-card ${expanded === index ? "expanded" : ""}`}
            style={{ backgroundImage: `url(${solution.img})` }}
            onClick={() => toggleExpand(index)}
          >
            <div className="solution-overlay">
              <h3>{solution.title}</h3>
              <p>{solution.desc}</p>
              {expanded === index && (
                <div className="solution-features">
                  {solution.features.map((feature, i) => (
                    <div key={i} className="feature-item">
                      <h4>{feature.name}</h4>
                      <p className="details">{feature.details}</p>
                      <p className="benefits"><strong>Benefits:</strong> {feature.benefits}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
